import { useRef } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const FormPhoneInput = ({
  label,
  required = false,
  value,
  onChange,
  onBlur,
  error,
  touched,
  country,
  name = "mobile",
  mode = "full",
  onCodeChange,
  onlyCountries = [],
}) => {
  const hasError = touched && error;
  const dropdownRef = useRef(null);

  const handleContainerClick = () => {
    const flagButton = dropdownRef.current?.querySelector('.selected-flag');
    if (flagButton) {
      flagButton.click();
    }
  };

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-secondary mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      <style>
        {`
          .react-tel-input .selected-flag:hover,
          .react-tel-input .selected-flag:focus,
          .react-tel-input .country-list .country:hover,
          .react-tel-input .flag-dropdown.open .selected-flag {
            background-color: #EAEEF1 !important;
          }
          
          .phone-input-clickable-wrapper {
            position: relative;
            cursor: pointer;
          }
          
          .phone-input-clickable-wrapper .react-tel-input .form-control {
            pointer-events: none;
          }
          
          .phone-input-clickable-wrapper .react-tel-input .flag-dropdown {
            pointer-events: auto;
          }
        `}
      </style>

      {mode === "dialCode" ? (
        <div
          ref={dropdownRef}
          className="phone-input-clickable-wrapper"
          onClick={handleContainerClick}
        >
          <PhoneInput
            country={country}
            enableSearch
            disableDropdown={false}
            disableCountryCode={false}
            countryCodeEditable={false}
            onlyCountries={onlyCountries.length > 0 ? onlyCountries : undefined}
            value={String(value || "").replace("+", "")}
            onChange={(_, countryData) => {
              onCodeChange?.("+" + countryData.dialCode, countryData.countryCode);
            }}
            onBlur={onBlur}
            inputProps={{
              name,
              required,
              readOnly: true,
            }}
            containerStyle={{ width: "100%" }}
            inputStyle={{
              width: "100%",
              height: "46px",
              fontSize: "14px",
              paddingLeft: "38px",
              borderRadius: "0.5rem",
              border: "none",
              backgroundColor: "#EAEEF1",
              outline: "none",
              color: "#111827",
              cursor: "pointer",
            }}
            buttonStyle={{
              border: "none",
              backgroundColor: "#EAEEF1",
              borderRadius: "0.5rem 0 0 0.5rem",
              cursor: "pointer",
            }}
            dropdownStyle={{
              position: "absolute",
              zIndex: 9999,
              maxHeight: "200px",
              overflow: "auto",
            }}
          />
        </div>
      ) : (
        <PhoneInput
          country={country}
          value={value}
          onChange={(phone, countryData) => {
            onChange("+" + phone);
            onCodeChange?.("+" + countryData.dialCode, countryData.countryCode);
          }}
          onBlur={onBlur}
          onlyCountries={onlyCountries.length > 0 ? onlyCountries : undefined}
          inputProps={{ name, required }}
          containerStyle={{ width: "100%" }}
          inputStyle={{
            width: "100%",
            height: "42px",
            fontSize: "14px",
            paddingLeft: "38px",
            borderRadius: "0.5rem",
            border: "none",
            backgroundColor: "#EAEEF1",
            outline: "none",
          }}
          buttonStyle={{
            border: "none",
            backgroundColor: "#EAEEF1",
            borderRadius: "0.5rem 0 0 0.5rem",
          }}
          dropdownStyle={{
            position: "absolute",
            zIndex: 9999,
            maxHeight: "200px",
            overflow: "auto",
          }}
        />
      )}

      {hasError && <p className="mt-1.5 text-xs text-red-600">{error}</p>}
    </div>
  );
};

export default FormPhoneInput;
